import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from './AppContext';
import './MenSection.css';

const MenSection = () => {
  const { products, lang } = useContext(AppContext);
  const isMr = lang === 'mr';
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const imageTimerRef = useRef(null);

  const menProducts = (products || []).filter(p =>
    p.subCategory === 'For Men' || p.forWhom === 'For Him' || p.category?.toLowerCase().includes('men')
  );

  const chains = menProducts.filter(p => p.category?.toLowerCase().includes('chain'));
  const rings = menProducts.filter(p => p.category?.toLowerCase().includes('ring'));
  const bracelets = menProducts.filter(p => p.category?.toLowerCase().includes('bracelet'));
  const kadas = menProducts.filter(p => p.category?.toLowerCase().includes('kada') || p.name?.toLowerCase().includes('kada'));

  const menCategories = [
    {
      title: isMr ? 'चेन्स' : 'Chains',
      sub: isMr ? 'जड चांदीच्या साखळ्या' : 'Heavy-duty silver chains',
      img: chains[0]?.image || '/images/men chain10.jpg',
      count: `${chains.length || 3}+ ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      products: chains.map(p => p.image).filter(Boolean).slice(0, 3),
      subCat: 'Chains'
    },
    {
      title: isMr ? 'अंगठ्या' : 'Rings',
      sub: isMr ? 'बोल्ड स्टेटमेंट अंगठ्या' : 'Bold statement rings',
      img: rings[0]?.image || '/images/men ring2.jpg',
      count: `${rings.length || 3}+ ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      products: rings.map(p => p.image).filter(Boolean).slice(0, 3),
      subCat: 'Rings'
    },
    {
      title: isMr ? 'ब्रेसलेट्स' : 'Bracelets',
      sub: isMr ? 'पॉवर कफ आणि बांगड्या' : 'Power cuffs & bangles',
      img: bracelets[0]?.image || '/images/men br8.jpg',
      count: `${bracelets.length || 2}+ ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      products: bracelets.map(p => p.image).filter(Boolean).slice(0, 3),
      subCat: 'Bracelets'
    },
    {
      title: isMr ? 'कडे' : 'Kadas',
      sub: isMr ? 'पारंपरिक आणि आधुनिक कफ' : 'Traditional & modern cuffs',
      img: kadas[0]?.image || '/images/men br6.jpg',
      count: `${kadas.length || 2}+ ${isMr ? 'स्टाईल्स' : 'Styles'}`,
      products: kadas.map(p => p.image).filter(Boolean).slice(0, 3),
      subCat: 'Bracelets'
    },
  ];

  const slideImages = menProducts.map(p => p.image).filter(Boolean);

  useEffect(() => {
    if (slideImages.length <= 1) return;
    imageTimerRef.current = setInterval(() => {
      setActiveSlideIndex(prev => (prev + 1) % slideImages.length);
    }, 1500);
    return () => clearInterval(imageTimerRef.current);
  }, [slideImages.length]);

  return (
    <section className="men-section" id="men">
      <div className="men-bg" />

      <div className="men-section-title-header reveal">
        <h2 className="men-section-title-text">
          {isMr ? 'पुरुषांचे' : "Men's"} <em>{isMr ? 'सिल्व्हर' : 'Silver'}</em> {isMr ? 'सिग्नेचर' : 'Signature'}
        </h2>
        <div className="title-ornament" style={{ marginTop: '10px' }}>
          <span style={{ background: 'linear-gradient(90deg, transparent, #E4DBCE, transparent)' }} />
          <span className="ornament-diamond" style={{ color: '#E4DBCE' }}>◆</span>
          <span style={{ background: 'linear-gradient(90deg, transparent, #E4DBCE, transparent)' }} />
        </div>
      </div>

      <div className="men-grid-layout">
        <div className="men-categories full-width">
          {menCategories.map((cat, i) => (
            <div
              key={i}
              className={`men-cat reveal delay-${i + 2}`}
              onClick={() => navigate(`/products?category=For+Men&subcategory=${encodeURIComponent(cat.subCat)}`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="men-cat-img">
                <img src={cat.img} alt={cat.title} onError={(e) => { e.currentTarget.src = '/images/men chain10.jpg'; }} />
                <div className="men-cat-overlay">
                  <div className="men-cat-mini-grid">
                    {(cat.products.length > 0 ? cat.products : [cat.img]).map((p, j) => (
                      <img key={j} src={p} alt="" className="mini-prod" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                    ))}
                  </div>
                </div>
                <div className="men-cat-label">
                  <span className="men-cat-count">{cat.count}</span>
                </div>
              </div>
              <div className="men-cat-info">
                <h3 className="men-cat-title">{cat.title}</h3>
                <p className="men-cat-sub">{cat.sub}</p>
                <div className="card-line" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenSection;
